// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nft-card[data-v-3cbe571a]{max-width:600px;width:100%}@media (min-width:1264px){.nft-card[data-v-3cbe571a]{max-width:none}}.nft-card.sold-out[data-v-3cbe571a]{order:9999}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
